module.exports = __webpack_public_path__ + "logo-symbol.7eee8110e3945eee1a59.png";


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/img/logo-symbol.png
// module id = ../../../../../src/img/logo-symbol.png
// module chunks = styles